const tabs = document.querySelector('.tabs_container');
const tabHeading = document.querySelectorAll('.collection_heading');
const tabContent = document.querySelectorAll('.collection_tab');

tabs.addEventListener('click', function(e){
  const clicked = e.target.closest('.collection_heading');

  if(!clicked) return;
  
tabHeading.forEach( th => th.classList.remove('collection_heading--active') );
tabContent.forEach( tc => tc.classList.remove('collection_tab--active') );
  
  clicked.classList.add('collection_heading--active');

  document.querySelector(`.collection_tab--${ clicked.dataset.tab }`).classList.add('collection_tab--active');
  
});